<template>
    <Skeleton class="flex flex-col">
        <div class="mb-0.5">
            <div class="skeleton-item-block h-16 w-full" />
        </div>
        <div class="flex items-center gap-0.5">
            <div class="skeleton-item-block h-12 w-40" />
            <div class="skeleton-item-block h-12 w-full" />
        </div>
        <div class="grid gap-10 py-6 px-4 lg:px-16 2xl:px-40 3xl:px-64 grid-cols-2 flex-grow rounded-md">
            <div class="skeleton-item-block h-full min-h-96 w-full rounded-md" />
            <div class="skeleton-item-block h-full min-h-96 w-full rounded-md" />
        </div>
    </Skeleton>
</template>

<script setup lang="ts">
import Skeleton from '@/components/RedesignBaseComponents/Loader/Skeleton.vue'
</script>

